// up-down 涨跌色
export const COLOR_GREEN = '#00A870';
export const COLOR_RED = '#F03A55';

// event 双选色
export const EVENT_LEFT_COLOR = '#327FFF';
export const EVENT_RIGHT_COLOR = '#FF6900';

// 通用 UI 色
export const GAP_COLOR = '#F5F6F7';
export const MUTED_COLOR = '#E4E4E4';
